/**
 * initLazy
 *
 */
let lazyInstance = null;

initLazy = function ($obj) {
	if(!$obj.length) return;

	lazyInstance = $obj.lazy({
		// your configuration goes here
		// scrollDirection: 'vertical',
		effect: 'fadeIn',
		effectTime: 100,
		threshold: 500,
		// visibleOnly: true,
		// delay:0,
		onError: function(element) {
			console.log('error loading ' + element.data('src'));
		}
	});
};



(function($j) {
	"use strict"; // Start of use strict

	// init barChartEventListener
	initLazy($('.lazy'));

})(jQuery); // End of use strict
